<template>
  <div class="w-100">
    <div class="w-100" v-if="window_width >= 576 && (image_list.length == 1 || image_list.length > 3)">
      <div class="row slim-grid-row-1">
        <div class="col-12" v-if="image_list.length == 1">
          <div class="w-100 h-400">
            <img :src="image_list[0].image_url" class="img-fit cursor-pointer h-400 radius-8"
              :alt="getMerchant.name">
          </div>
        </div>
        <template v-else>
          <div class="col-xl-8 col-lg-7 col-sm-6">
            <img 
              @click="setActiveImage(0)"
              :src="image_list[0].image_url" class="w-100 img-slider-1 h-400 cursor-pointer"
              :alt="getMerchant.name">
          </div>
          <div class="col-xl-4 col-lg-5 col-sm-6 h-400 overflow-hidden">
            <div class="row slim-grid-row-1">
              <div class="col-12 mb-2">
                <div class="row slim-grid-row-1">
                  <div class="col-6">
                    <img @click="setActiveImage(1)" :src="image_list[1].image_url" class="w-100 img-slider-2 cursor-pointer"
                      :alt="getMerchant.name">
                  </div>
                  <div class="col-6">
                    <img @click="setActiveImage(2)" :src="image_list[2].image_url" class="w-100 img-slider-3 cursor-pointer"
                      :alt="getMerchant.name">
                  </div>
                </div>
              </div>
              <div class="col-12 position-relative">
                <img @click="setActiveImage(3)" :src="image_list[3].image_url" class="w-100 img-slider-4 cursor-pointer"
                  :alt="getMerchant.name">
                <button v-if="image_list.length > 4" type="button" @click="setActiveImage(4)"
                  class="g-btn bg-white g-btn-sm position-absolute px-3 cursor-pointer"
                  style="bottom: 18px;right: 24px;">View More</button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-else class="w-100 position-relative">
      <flickity ref="main_slider" :options="$basic_slider_option" class="spa-product">
        <div class="carousel-cell w-100" :id="slider_merchant.id"
          v-for="(slider_merchant,index) in  image_list">
          <div class="w-100 h-400-responsive">
            <img @click="setActiveImage(index)" :src="slider_merchant.image_url"
              class="img-fit h-400-responsive radius-8 cursor-zoom" :alt="getMerchant.name">
          </div>
        </div>
      </flickity>
      <div class="concierge-slider-btn right" @click="clickButtonSlider('next')">
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16.5" cy="16.5" r="16" fill="white" stroke="#D9D9D9" />
          <path
            d="M20 16.5202C20 16.3324 19.9249 16.1446 19.7821 16.0169L13.8253 10.2028C13.6976 10.0751 13.5324 10 13.3446 10C12.954 10 12.6535 10.293 12.6535 10.6836C12.6535 10.8714 12.7286 11.0441 12.8488 11.1719L18.7305 16.9258V16.1221L12.8488 21.8761C12.7286 21.9962 12.6535 22.169 12.6535 22.3643C12.6535 22.7549 12.954 23.0479 13.3446 23.0479C13.5324 23.0479 13.6976 22.9728 13.8329 22.8451L19.7821 17.031C19.9249 16.8883 20 16.7155 20 16.5202Z"
            fill="black" fill-opacity="0.85" />
        </svg>
      </div>
      <div class="concierge-slider-btn left" @click="clickButtonSlider('previous')">
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16.5" cy="16.5" r="16" fill="white" stroke="#D9D9D9" />
          <path
            d="M12.6535 16.5277C12.6535 16.7155 12.7286 16.9033 12.8714 17.031L18.8282 22.8451C18.9559 22.9728 19.1211 23.0479 19.3089 23.0479C19.6995 23.0479 20 22.7549 20 22.3643C20 22.1765 19.9249 22.0038 19.8047 21.876L13.923 16.1221V16.9258L19.8047 11.1718C19.9249 11.0516 20 10.8789 20 10.6836C20 10.293 19.6995 10 19.3089 10C19.1211 10 18.9559 10.0751 18.8207 10.2028L12.8714 16.0169C12.7286 16.1596 12.6535 16.3324 12.6535 16.5277Z"
            fill="black" fill-opacity="0.85" />
        </svg>
      </div>
    </div>

    <CoolLightBox 
      :items="image_list" 
      srcName="image_url" 
      :index="active_image"
      closeOnClickOutsideMobile
      @close="active_image = null">
    </CoolLightBox>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import CoolLightBox from 'vue-cool-lightbox'
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

  export default {
    props: {
      image_list:{
        type: Array,
        default: () => []
      }
    },
    components:{
      CoolLightBox
    },
    data(){
      return{
        active_image: null,
        window_width: window.innerWidth
      }
    },
    computed:{
      ...mapGetters(['getMerchant'])
    },
    mounted(){
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
    },
    beforeDestroy() { 
      window.removeEventListener('resize', this.onResizeWindow); 
    },
    methods:{
      setActiveImage(index){
        this.active_image = index
      },
      onResizeWindow(){
        this.window_width = window.innerWidth
      },
      clickButtonSlider(type){
        if(type == 'next') this.$refs.main_slider.next()
        else this.$refs.main_slider.previous()
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/general/HomeSlider.vue